<ngx-spinner bdColor="rgba(51,51,51,0.60)" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">{{'Cargando' | translate}}...</p>
</ngx-spinner>
<router-outlet></router-outlet>
